import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "table1"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { USER_TYPE } from '../config';
import { indexMethod } from '@/utils/indexMethod';
export default {
  __name: 'table',
  props: {
    data: {
      type: Array
    },
    page: {
      type: Number
    },
    size: {
      type: Number
    },
    total: {
      type: Number
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['onShowRoleClick', 'delUserHandler', 'handleCurrentChange', 'updateUser'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const onShowRoleClick = row => {
      emit('onShowRoleClick', row);
    };
    const handleUpdateUser = row => {
      emit('updateUser', row);
    };
    const delUserHandler = row => {
      emit('delUserHandler', row);
    };
    const handleCurrentChange = val => {
      emit('handleCurrentChange', val);
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: __props.data,
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "#",
          type: "index",
          index: index => _unref(indexMethod)(index, __props.page, __props.size)
        }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "用户名"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_2, [row.picture ? (_openBlock(), _createBlock(_component_el_avatar, {
            key: 0,
            size: 50,
            src: row.picture,
            style: {
              "margin-right": "10px"
            }
          }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(row.name), 1)])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "username",
          label: "账号"
        }), _createVNode(_component_el_table_column, {
          prop: "lastLoginClinic",
          label: "最后登录诊所"
        }), _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "手机号"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间"
        }), _createVNode(_component_el_table_column, {
          label: "用户类型"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(USER_TYPE)[row === null || row === void 0 ? void 0 : row.type]), 1)]),
            _: 2
          }, 1024)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "260"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "info",
            size: "small",
            onClick: $event => onShowRoleClick(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 角色 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => handleUpdateUser(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 修改 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "danger",
            size: "small",
            onClick: $event => delUserHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, __props.loading]]), _createVNode(_component_el_pagination, {
        class: "pagination",
        onCurrentChange: handleCurrentChange,
        "current-page": __props.page,
        "page-size": __props.size,
        layout: "total,  prev, pager, next, jumper",
        total: __props.total
      }, null, 8, ["current-page", "page-size", "total"])]);
    };
  }
};